module.exports = __webpack_public_path__ + "img/image-rectangle.baf1d7e.jpg";